import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class PayrollTypeAssignFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async onChange(value, field) {
    const seen = new Set();
    const filteredValue = [];

    for (const item of value) {
      if (!seen.has(item?.payrollType?.id)) {
        seen.add(item?.payrollType?.id);
        filteredValue.push(item);
      }
    }

    if (filteredValue.length < value.length) {
      this.showError(
        "Duplicate earnings are not allowed. Only the first entry was kept.",
        "Duplicate Removed!",
        "bi bi-info-circle"
      );
    }

    this.change[field] = filteredValue;
    this.object[field] = filteredValue;
    this.view.setObject(this.object);
  }

  async save() {
    const collection = this.view.getCollectionName();
    const change = this.change;

    try {
      if (this.view.props.selected.length > 0) {
        const updatePromises = this.view.props.selected.map(({ id }) => {
          const updateData = {
            id,
            payrollClassification: change.payrollClassification,
          };

          return this.upsertUseCase.execute(collection, updateData);
        });

        await Promise.all(updatePromises);
      } else if (this.view.props.mode === "edit") {
        const updateData = {
          id: this.view.props.employeeData?.id,
          payrollClassification: change.payrollClassification,
        };

        await this.upsertUseCase.execute(collection, updateData);
      } else { 
        console.log("No employees found.");
      }
      this.view.props.refetchData();
      this.view.props.closeModal();
      this.view.props.savedData();
    } catch (error) {
      throw error;
    }
  }
}

export default PayrollTypeAssignFormPresenter;
